// 接入架构组文件上传
import { ts_md5_file } from '../components/uploadMaterial/md5';
import { uploadUrl } from '../serve/uploadMaterial';
import axios from 'axios';
export default {
  data() {
    return {
      abortControllers: new Map(),
    };
  },
  methods: {
    async useUpLoadFile(file, options) {
      const { md5 } = await ts_md5_file(file);

      // 创建取消控制器
      const abortController = new AbortController();
      const fileKey = file.uid;
      this.abortControllers.set(fileKey, abortController);
      const contentType = file.type || 'application/octet-stream';

      // 调用架构组的上传接口。如果存在uploadUrl则使用put上传
      try {
        const res = await uploadUrl({
          sceneCode: options?.sceneCode || 'internal_oss',
          domainCode: options?.domainCode || 'marketing/ad',
          acl: options?.acl || 'default',
          fileName: file.name,
          contentType,
          md5,
          size: file.size,
        });

        if (res.data.uploadUrl) {
          try {
            await axios.put(res.data.uploadUrl, file, {
              headers: {
                'Content-Type': contentType,
                'x-oss-object-acl': options?.acl || 'default',
                'Cache-Control': 'max-age=2592000',
              },
              onUploadProgress: (progressEvent) => {
                let progressEvt = progressEvent;
                progressEvt.percent =
                  progressEvt.total > 0 ? parseFloat(((progressEvt.loaded / progressEvt.total) * 100).toFixed(2)) : 0;
                if(this.onProgress){
                  this.onProgress(progressEvt, file);
                }
                if (typeof options?.elOptions?.onUploadProgress === 'function') {
                  options.elOptions.onUploadProgress(progressEvt);
                }
              },
            });
          } catch (error) {
            // 如果是取消请求，不显示错误信息
            if (axios.isCancel(error) || error?.name === 'AbortError') {
              console.log('上传请求已取消');
              throw error;
            }
            console.log(error, '推送至存储桶失败，请重试');
            throw error;
          }
        }
        const ext = file.type ? file.type.split('/')[1] : file.name.match(/\.(\w+)$/)?.[0] || '';
        const data = {
          ...res.data,
          name: file.name,
          ext: '.' + ext,
        };
        return data;
      } catch (error) {
        console.log('uploadMaterial httpRequest error', error);
        return { status: 'error', name: file.name };
      } finally {
        this.abortControllers.delete(fileKey);
      }
    },
    // 取消上传请求
    cancelUpload(fileUid) {
      const abortController = this.abortControllers.get(fileUid);
      if (abortController) {
        abortController.abort();
        this.abortControllers.delete(fileUid);
      }
    },
  },
};
